<template>
  <el-tooltip :content="content" placement="top" :disabled="disabled">
    <div class="template-text-conent" ref="templateTextConent">
      <span class="template-text" ref="treeNodeText"> {{ content || '' }}</span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'TreeTagText',
  props: {
    content: { type: String, default: '' }
  },
  data() {
    return {
      disabled: false
    }
  },
  watch: {
    content: {
      handler() {
        this.loading()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    loading() {
      this.$nextTick(() => {
        const conent = this.$refs.templateTextConent
        const text = this.$refs.treeNodeText

        if (!conent || !text) {
          setTimeout(() => {
            this.loading()
          }, 1000)
          return
        }

        const textWidth = text.offsetWidth
        const conentWidth = conent.offsetWidth
        this.disabled = textWidth < conentWidth
      })
    }
  },
  mounted() {
    this.loading()
  }
}
</script>

<style lang="scss" scoped>
.template-text-conent {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 230px;
}
</style>